angular.module('unergie.main')
.controller('createManagementSheetModalCtrl', ($scope, $uibModalInstance, $timeout, ApiUser, DataAccess, DataAccessSearch, BoFeaturesService, AlertManager, ErrorCatcher) => {
    const canCreateOrgManagementSheet = BoFeaturesService.isFeatureOn('canCreateOrgManagementSheet')

    $scope.managementSheetPayload = {}

    const fetchInvoicedPeriods = (search) => {
        $scope.fetchingInvoicedPeriods = true
        return DataAccess.availableMetaPeriods(search).$promise
        .then((periods) => {
            if (periods.start.length || periods.end.length) {
                $scope.periodStarts = periods.start
                $scope.periodEnds = periods.end
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingInvoicedPeriods = false
        })
    }

    $scope.selectCategory = (category) => {
        $scope.managementSheetPayload.id_category = category.id
        if ($scope.managementSheetPayload.id_category !== null) {
            $scope.managementSheetPayload.generateSubSheets = false
            fetchInvoicedPeriods({ id_category: category.id })
        }
    }

    $scope.fetchCategoriesForAccount = (account) => {
        $scope.managementSheetPayload.id_account = account && account.id
        if (!account || !account.id) {
            return
        }
        fetchInvoicedPeriods({ id_account: account.id })
        $scope.fetchingCategories = true
        return DataAccessSearch({ columns: ['id', 'name'], orderBy: 'name' })
        .searchPaginated({ resource: 'ref-contract-category', id_account: account.id }).$promise
        .then((result) => {
            $scope.categories = result.results
            if ($scope.categories.length === 1) {
                $scope.managementSheetPayload.id_category = $scope.categories[0].id
            } else if ($scope.categories.length) {
                $scope.categories.unshift({ id: null, name: '~ Tous ~' })
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingCategories = false
        })
    }

    $scope.fetchAccountsForOrg = (org) => {
        if (!org) {
            return
        }
        fetchInvoicedPeriods({ organization: org.id })
        $scope.managementSheetPayload.organization = org.id
        $scope.fetchingAccounts = true
        return DataAccess.myAccounts({ organization: org.id, light: true }).$promise
        .then((accounts) => {
            $scope.accounts = accounts
            if ($scope.accounts.length === 1) {
                return $scope.fetchCategoriesForAccount($scope.accounts[0])
            }
            if ($scope.accounts.length && canCreateOrgManagementSheet) {
                $scope.accounts.unshift({ id: null, brand: '~ Tous ~' })
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingAccounts = false
        })
    }

    const activate = () => {
        $scope.fetchingOrgz = true
        return DataAccess.myOrganizations().$promise
        .then((myOrganizations) => {
            $scope.organizations = _.orderBy(_.filter(myOrganizations, (org) => ['B2G', 'B2B'].includes(org.type)), 'id')
            if ($scope.organizations.length === 1) {
                $scope.fetchAccountsForOrg($scope.organizations[0])
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $timeout(() => {
                $scope.fetchingOrgz = false
            })
        })
    }

    $scope.createManagementSheet = () => {
        let type
        const payload = {
            start_date: moment($scope.managementSheetPayload.start_date).format('YYYY-MM-DD'),
            end_date: moment($scope.managementSheetPayload.end_date).add(1, 'month').format('YYYY-MM-DD'),
        }
        if ($scope.managementSheetPayload.id_category) {
            type = 'CATEGORY'
            payload.id_category = $scope.managementSheetPayload.id_category
        } else if ($scope.managementSheetPayload.id_account) {
            type = 'ACCOUNT'
            payload.id_account = $scope.managementSheetPayload.id_account
        } else {
            type = 'ORGANIZATION'
            payload.organization = $scope.managementSheetPayload.organization
        }
        $scope.generating = true
        return ApiUser.createManagementSheet({ type, generateSubSheets: $scope.managementSheetPayload.generateSubSheets }, payload).$promise
        .then((result) => {
            AlertManager.success('Création lancée, vous recevrez un email lorsque la génération sera terminée.')
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.generating = false
        })
    }

    $scope.canGenerate = () => {
        return $scope.managementSheetPayload.organization &&
            $scope.managementSheetPayload.id_account !== undefined &&
            ($scope.managementSheetPayload.id_account === null || $scope.managementSheetPayload.id_category !== undefined) &&
            $scope.managementSheetPayload.start_date &&
            $scope.managementSheetPayload.end_date
    }

    activate()

    $scope.close = () => $uibModalInstance.dismiss()
})
